/* @flow */

import getInputPorId from '../utils/get-input-por-id';

const resetFormulario = () => {
    const forms = document.querySelectorAll('form');

    forms.forEach((form) => {
        form.reset();
    });
    getInputPorId('endereco-id').value = '';
};

export default resetFormulario;
